import baseTypes from './types/base'
import baseService from '@/api/base'

const state = {}

const actions = {
  /**
   * 获得数据字典
   */
  [baseTypes.GET_DICT] ({ commit }, { type = '' }) {
    return new Promise((resolve, reject) => {
      baseService.getDict({ type }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获得流域信息
   */
  [baseTypes.GET_CACD] ({ commit }, { pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      baseService.getCacd({ pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获得基本行政区划信息
   */
  [baseTypes.GET_BASEADCD] ({ commit }, { IsTown, IsCounty, ParentAdcdCode = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      baseService.getBaseAdcd({ IsTown, IsCounty, ParentAdcdCode, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获得新增用户行政区划信息
   */
  [baseTypes.GET_BASEUSERADCD] ({ commit }, { IsTown, IsCounty, ParentAdcdCode = '', pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      baseService.getBaseUserAdcd({ IsTown, IsCounty, ParentAdcdCode, pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
